<template>
    <section class="centered-page pb-10 text-white mt-20 pt-10">
        <img class="component-header flex justify-center mb-10" src="images/partner.png" />
        <div class="flex justify-content items-center">
          <img class="partner-img" src="images/solana.png">
          <img class="partner-img" src="images/dex.png">
          <img class="partner-img" src="images/phantom.webp">
          <img class="partner-img" src="images/raydium.webp">
          <img class="partner-img" src="images/coingecko.webp">
        </div>
    </section>
</template>

<script>
export default {
  name: 'PartnersPage',
};
</script>

<style scoped>

.title {
  font-size: 1.8rem; /* Adjust size as needed */
  color: #FFF; /* Adjust color as needed */
  font-weight: bold;
}

.centered-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.partner-img {
  height: 60px;
  margin: 10px 40px;
}
</style>